// extracted by css-extract-rspack-plugin
export default {"cls1":"ReferenceCard-cls1_1yL","cls2":"ReferenceCard-cls2_kuQ ReferenceCard-cls1_1yL"};